// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"PendingRewardWidget_scrollable__xGKaW"};